var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31246 13.5H17.8125C18.2103 13.5 18.5918 13.3419 18.8731 13.0606C19.1544 12.7793 19.3124 12.3978 19.3124 12C19.3124 11.6022 19.1544 11.2206 18.8731 10.9393C18.5918 10.658 18.2103 10.5 17.8125 10.5H4.31246C2.69635 10.5 1.38623 11.8431 1.38623 13.5C1.38623 15.1569 2.69635 16.5 4.31246 16.5H17.9994C19.1929 16.5 20.3375 16.0259 21.1814 15.182C22.0253 14.3381 22.4994 13.1935 22.4994 12C22.4994 10.8065 22.0253 9.66193 21.1814 8.81802C20.3375 7.97411 19.1929 7.5 17.9994 7.5H7.49941",
    stroke: "#808191",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.8149a299667c4074b72a321d65a0e317.svg";
export { ForwardRef as ReactComponent };